
import defaultSettings from '../../../settings.js'
console.log(defaultSettings);

const { sideTheme, showSettings, topNav, tagsView, fixedHeader, sidebarLogo, dynamicTitle, pageLoading, aiAssistant } = defaultSettings

const storageSetting = JSON.parse(localStorage.getItem('layout-setting')) || ''
console.log(storageSetting,'5555555555555');
const state = {
  theme: storageSetting.theme || '#1476FF',
  Skin: storageSetting.Skin || '',
  topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
  tagsView: storageSetting.tagsView === undefined ? tagsView : storageSetting.tagsView,
  pageLoading: storageSetting.pageLoading === undefined ? pageLoading : storageSetting.pageLoading,
  aiAssistant: storageSetting.aiAssistant === undefined ? aiAssistant : storageSetting.aiAssistant,
  aiAccessToken: null,
}
const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  // 修改布局设置
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  },
  // 设置网页标题
  setTitle({ commit }, title) {
    state.title = title
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

